import React from 'react';
import s from './Pagination.module.scss';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const handlePageChange = (page: number) => {
    if (page !== currentPage) {
      onPageChange(page);
    }
  };

  // 常に表示するページ数（最大5個）
  const maxPagesToShow = 5;
  const pages: (number | string)[] = [];

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);

    if (currentPage > 4) {
      pages.push('...');
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 3) {
      pages.push('...');
    }

    pages.push(totalPages);
  }

  // 常に5ページを超えないように調整
  // if (pages.length > maxPagesToShow) {
  //   pages.splice(5);  // 5個以上のページが表示されないようにする
  // }

  return (
    <div className={s.pagination}>
      <button
        className={`${s.pageButton} ${currentPage === 1 ? s.disabled : ''}`}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      {pages.map((page, index) => (
        <button
          key={index}
          className={`${s.pageButton} ${page === currentPage ? s.active : ''}`}
          onClick={() => typeof page === 'number' ? handlePageChange(page) : undefined}
          disabled={typeof page === 'string'}  // 「...」はクリックできない
        >
          {typeof page === 'number' ? page : '...'}
        </button>
      ))}

      <button
        className={`${s.pageButton} ${currentPage === totalPages ? s.disabled : ''}`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination;
